import React from 'react';
import { cn } from '../../lib/utils';

interface LoadingProps {
  size?: 'sm' | 'md' | 'lg';
  text?: string;
  className?: string;
  fullScreen?: boolean;
}

const Loading: React.FC<LoadingProps> = ({ 
  size = 'md', 
  text, 
  className,
  fullScreen = false 
}) => {
  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-8 w-8', 
    lg: 'h-12 w-12'
  };

  const containerClasses = fullScreen 
    ? 'fixed inset-0 bg-background flex items-center justify-center z-50'
    : 'flex items-center justify-center py-4';

  return (
    <div className={cn(containerClasses, className)}>
      <div className={cn(
        'animate-spin rounded-full border-b-2 border-brand-600',
        sizeClasses[size]
      )}></div>
      {text && (
        <p className="mt-4 text-muted-foreground text-sm">
          {text}
        </p>
      )}
    </div>
  );
};

export default Loading; 